import LiveSupportChat from '../shared/LiveSupportChat';
import API_BASE from '../../utils/apiBase';

function WorkerLiveSupportChatWrapper({ currentShiftContext = null, supportRequest = 0 }) {
  const getToken = () => localStorage.getItem('workerToken');
  const apiBase = API_BASE;

  return (
    <LiveSupportChat
      openRequest={supportRequest}
      showLauncher={false}
      userType="worker"
      getAuthToken={getToken}
      apiBase={apiBase}
      initialContext={currentShiftContext}
      title="Live Support - Talk to an admin"
    />
  );
}

export default function WorkerDashboardPage({
  header,
  supportRequest = 0,
  nextAction,
  readinessChecklist,
  agreements,
  documents,
  training,
  checks,
  support,
  children,
}) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F8FAFA] via-white to-[#F0F7F7]">
      <a href="#worker-dashboard-main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:rounded-lg focus:bg-white focus:p-3">Skip to dashboard</a>
      {header}
      <main id="worker-dashboard-main" tabIndex={-1} className="mx-auto flex max-w-4xl flex-col gap-4 px-4 py-5 pb-24 md:pb-6">
        {nextAction}
        {readinessChecklist}
        {agreements}
        {documents}
        {training}
        {checks}
        {support}
        {children}
      </main>

      <WorkerLiveSupportChatWrapper currentShiftContext={null} supportRequest={supportRequest} />
    </div>
  );
}